module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#f3f3f3",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "logo-header"
  }, [(_vm.logoProviderConfirmation === '') ? _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "titulo-logo mb-4 float-l"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingLogo),
      expression: "!loadingLogo"
    }],
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingLogo),
      expression: "!loadingLogo"
    }]
  }, [_vm._v("CondoPlaza")])])]) : _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.logoProviderConfirmation,
    attrs: {
      "src": _vm.logoProviderConfirmation,
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingLogo),
      expression: "loadingLogo"
    }],
    staticClass: "progrees-line",
    attrs: {
      "indeterminate": true,
      "height": "2",
      "color": "red",
      "background-color": "white"
    }
  })], 1), _vm._v(" "), (!_vm.loadingLogo) ? _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "box-email"
  }, [_c('div', {
    staticClass: "text-xs-center call-cupom"
  }, [_c('strong', [_vm._v(_vm._s(_vm.defaultText))])])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-265e5adb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sentCanceled/sentCanceled.vue
// module id = 738
// module chunks = 29